// extracted by mini-css-extract-plugin
export default {"speNav":"index_speNav_U3C6K"};